<template>
  <div class="card-modern">
  
    <!-- HEADER -->
    <div class="d-flex align-items-start justify-content-between mb-3 flex-wrap gap-3">
      <div>
        <h3 class="card-title-modern">Monitoring Aset Infrastruktur IT</h3>
        <p class="card-desc-modern mb-0">
          Kelola data server, switch, dan perangkat jaringan lainnya.
        </p>
      </div>
    </div>
    <div class="d-flex align-items-center justify-content-end gap-2 mb-3 flex-wrap">
      <div style="position: relative; width: 200px;">
        <i class="bi bi-search text-muted"
          style="position: absolute; left: 10px; top: 50%; transform: translateY(-50%); z-index: 1;"></i>
        <input v-model="filters.search" class="form-control" placeholder="Cari / asset number"
          style="padding-left: 32px; border-radius: 8px;" @input="applyFilters" />
      </div>
      <select v-model="filters.device_category" class="form-select" style="width: 150px;" @change="applyFilters">
        <option value="">Semua Kategori</option>
        <option v-for="cat in deviceCategoryList" :key="cat.value" :value="cat.value">
          {{ cat.description }}
        </option>
      </select>
      <select v-model="filters.status" class="form-select" style="width: 150px;" @change="applyFilters">
        <option value="">Semua Status</option>
        <option value="active">Active</option>
        <option value="inactive">Inactive</option>
        <option value="expired">Expired</option>
      </select>
      <button class="button-modern" @click="goToAdd">+ Add Asset</button>
    </div>
    <!-- TABLE -->
    <div class="modern-table-wrapper">
      <table class="table-modern">
        
        <thead>
          <tr>
            <th>Asset Number</th>
            <th>Device Type</th>
            <th>Kategori</th>
            <th>Site</th>
            <th>Departement</th>
            <th>Lokasi</th>
            <th>Status</th>
            <!-- <th>Tgl Pembelian</th> -->
            <!-- <th class="text-center">Total Item</th> -->
            <th class="text-center">Aksi</th>
          </tr>
        </thead>
        <tbody>
          <tr v-if="loading">
            <td colspan="8" class="text-center py-4">
              <div class="spinner-border spinner-border-sm me-2"></div>
              Memuat data...
            </td>
          </tr>
          <tr v-else-if="infras.length === 0">
            <td colspan="8" class="text-center py-4 text-muted">
              Tidak ada data infrastruktur
            </td>
          </tr>
          <tr v-else v-for="item in infras" :key="item.infrastructure_id">
            <td style="max-width: 220px; white-space: normal; word-break: break-word;">
              {{ item.asset_numbers || '-' }}
            </td>
            <td>{{ item.device_type_names || '-' }}</td>
            
            <td>{{ item.device_category_name || '-' }}</td>
            <td>{{ item.mst_site_name || '-' }}</td>
            <td>{{ item.mst_division_name || '-' }}</td>
            <td>{{ item.initial_location_device || item.final_location_device || '-' }}</td>  
            <td>
              <span v-if="headerStatus(item)" class="badge-modern" :class="headerStatus(item).cls"
                :title="headerStatus(item).title">
                {{ headerStatus(item).label }}
              </span>
              <span v-else class="text-muted">-</span>
            </td>
            <!-- <td>{{ item.purchase_date || '-' }}</td> -->
            <!-- <td class="text-center">
                <span class="badge-modern badge-info">
                  {{ item.total_detail }} item
                </span>
              </td> -->
            <td class="text-center">
              <button class="btn-icon-hover icon-warning" @click="goToEdit(item.infrastructure_id)" title="Edit">
                <i class="bi bi-pencil"></i>
              </button>
              <button class="btn-icon-hover icon-primary" @click="goToDetail(item.infrastructure_id)" title="Detail">
                <i class="bi bi-eye"></i>
              </button>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  
    <!-- PAGINATION -->
    <div class="d-flex justify-content-between align-items-center mt-3">
      <small class="text-muted">
        Menampilkan {{ (page - 1) * perPage + 1 }} - {{ Math.min(page * perPage, total) }} dari {{ total }} data
      </small>
      <div class="d-flex align-items-center gap-2">
        <small class="text-muted">Rows per page</small>
        <select v-model.number="perPage" class="form-select form-select-sm" style="width: 70px;" @change="changePerPage">
          <option v-for="opt in perPageOptions" :key="opt" :value="opt">{{ opt }}</option>
        </select>
        <nav>
          <ul class="pagination pagination-sm mb-0">
            <li class="page-item" :class="{ disabled: page === 1 }">
              <button class="page-link" @click="changePage(page - 1)">‹</button>
            </li>
            <li v-for="(p, idx) in visiblePages" :key="idx" class="page-item"
              :class="{ active: p === page, disabled: p === '...' }">
              <button class="page-link" @click="p !== '...' && changePage(p)">{{ p }}</button>
            </li>
            <li class="page-item" :class="{ disabled: page === totalPages }">
              <button class="page-link" @click="changePage(page + 1)">›</button>
            </li>
          </ul>
        </nav>
      </div>
    </div>
  
  </div>
</template>
<script>
import InfrasViewJs from "./InfrasView";
export default InfrasViewJs;
</script>